<template lang="pug">
.c-form__form-row.c-form__form-row--full.comment--box
    //- .strategic-wrapper( v-if="executive" )
    //-     label.c-form__form-label(for="comment") ¿Es cliente estratégico?
    //-     toggle-button(
    //-         :id="field.id"
    //-         :value="isStrategic"
    //-         @change="$emit('update:isStrategic', !isStrategic)"
    //-         :color="toggleColor"
    //-         :labels="{checked: 'SI', unchecked: 'NO'}"
    //-     )
      //- .c-form__form-row
      //-   label.c-form__form-label(for="tasa") Tasa %
      //-   input.c-form__form-input.tasa(
      //-     id="tasa"
      //-     name="tasa"
      //-     type="number"
      //-     v-model="tasa"
      //-     step=".01"
      //-     @input="handleInput"
      //-     @keyup.delete="handleBackspaceTasa"
      //-     )
      //-   div.tasa-wrapper
      //-     div.c-form__form-input.center(
      //-         name="tasa"
      //-         @click="clickInput"
      //-         step=".01"
      //-     ) 
      //-       div {{number}}
      //-       div %
      //-   label.error-label {{errorTasa}}

        //- PRIMA DE CREACIÓN    div(class="input-money")
        select(
                class="selectCurrency"
                v-model="PremiumCurrency"
                @change="handleSelectPremiumCurrency"
            )
              option(value="USD") $
        input(
            :name="field.id"
            :id="field.id"
            maxlength="20"
            v-model="field.value"
            @input="handleInput"
            class="c-form__form-input input-currency"
            :required="!!field.required"
        )
        label(v-if="showPrimeError" class="error-label") Ingresa máximo 15 dígitos con 2 decimales
    .wrapper-column(v-if="isPrimaActive")
      .c-form__form-row
        label.c-form__form-label(for="PRIMA") prima neta (*)
        div( class="money-field-wrapper")
          div(class="input-money")
            select(
                    class="selectCurrency"
                    v-model="reply.premium_currency"
                )
                  option(value="USD") $
                  option(value="PEN") S/
            input(
                maxlength="20" 
                v-model="reply.premium"
                @input="handlePrima"
                class="c-form__form-input input-currency"
            ) 
          label(class="error-label") {{errorPrima}}
    div(class="select-suscriptor-wrapper" v-if="fetchSelectAssigneeActive && currentAction=='derive' && !this.isValidatedStrategic && this.teamBagName !== 'Responsabilidad Civil, Deshonestidad, 3D y Robo' && this.teamBagName !== 'Multiriesgo e Incendio' ") 
      div(class="title-suscriptor") La cotización será atendida por el equipo de {{teamBagName}}
      .c-form__form-row.c-form__form-row--full(v-if="executive")
        label(class="c-form__form-label") SUSCRIPTOR(*)
        select(class="select-technical" id="technical", name="technical", @select="handleSelect" v-model="reply.technical_assignee", required)
          option(
            :value="technicalStrategic.id"
            v-for="technicalStrategic in technicalStrategicList"
          ) {{technicalStrategic.full_name}}
    .c-form__form-row--full.margin
      label.c-form__form-label(for="comment") {{labelTextArea}}
      b-input.comment-area(name="comment", id="comment" v-model="reply.text" maxlength="500" type="textarea")
    .c-form__form-row
      label.c-form__form-label(for="comment") ADJUNTAR ARCHIVO
      input-file.attachment(
          :field="field"
          :dropFiles="dropFiles"
          key="cf1"
      )
    label(for="observed", class="c-form__form-label", v-if="enabledFilter") ¿Esta cotización tiene observaciones?
    toggle-button(:color="toggleColor", :labels="{checked: 'SI', unchecked: 'NO'}", v-model="reply.observed", :sync="true", v-if="enabledFilter")
    button.button.button--black(
        @click="sendAction",
        :class="{active: activeButton}",
        :disabled="!activeButton"
    ) Enviar
</template>

<script>
import InputFile from '../components/fields/InputFileComment.vue';
import { isExecutive, isTechnical } from '../mixins/user';
import { maxDigitsAndDecimals } from '../utils/validations';
import { $green } from '../globals';



export default {
    name: 'AppCommentBox',
    components: {
        InputFile
    },
    props: {
        reply: Object,
        enabledFilter: Boolean,
        type: String,
        isStrategic: false,
        submitButton: true,
        labelTextArea: String,
        isValidatedStrategic: Boolean,
        fetchIsTechnical: Boolean,
        technicalStrategicList: Array,
        currentAction: String,
        dropFiles: Array,
        fetchSelectAssigneeActive: Boolean,
        fetchIdSoatVehicular: Number,
        fetchDerivationType: String,
        isPrimaActive: Boolean,
        teamBagName: String
    },
    data() {
        return {
            field: {
                id: 'C1',
                name: 'adjunto',
                value: {},
            },
            tasa:null,
            prima:null,
            errorTasa: "",
            errorPrima: "",
            isFocus: false,
        }
    },
    mounted(){
    },
    computed: {
        number() {
          if ( this.tasa ) {
            this.$emit('tasa', parseFloat(this.tasa).toFixed(5))
            return parseFloat(this.tasa).toFixed(5)
          } else {
            this.$emit('tasa', this.tasa)
            return this.tasa
          }
        },
        primawithformat() {
          if( this.prima) {
            this.$emit('prima', parseFloat(this.prima).toFixed(2))
            return parseFloat(this.prima).toFixed(2)
          } else {
            this.$emit('prima', this.prima)
            return this.prima
          }
        },
        toggleColor() {
            return $green;
        },
        activeButton() {
            if(this.fetchSelectAssigneeActive && this.currentAction=='derive'&& !this.isValidatedStrategic && this.teamBagName !== 'Responsabilidad Civil, Deshonestidad, 3D y Robo' && this.teamBagName !== 'Multiriesgo e Incendio') {
              return !!this.reply.text && !!this.submitButton && !this.$store.state.fileCommentIsLoading && this.reply.technical_assignee;
            } else if(this.isPrimaActive) {
              return !!this.reply.text && !!this.submitButton && !this.$store.state.fileCommentIsLoading && !this.errorTasa && !this.errorPrima && this.reply.premium.toString().length > 0 ;  
            } else {
              return !!this.reply.text && !!this.submitButton && !this.$store.state.fileCommentIsLoading;
            }
        },
        executive() {
            return isExecutive();
        },
        technical() {
          return isTechnical()
        }

    },
    methods: {
        sendAction () {
          this.$emit('sendReply');
        },

        handleBackspaceTasa() {
          this.tasa = null
          this.errorTasa = ""
        },

        handleBackspacePrima() {
          this.prima = null
          this.errorPrima = ""
        },

        handleSelect() {
          this.$emit('handleSuscriptorSelect')
        },

        handleInput() {
          this.errorTasa = ""
          if(this.tasa > 100) {
            this.errorTasa = "La tasa debe ser menor que el 100%"
          } else if (this.tasa < -100) {
            this.errorTasa = "La tasa debe ser mayor que el -100%"
          } 
        },

        handlePrima() {
          this.errorPrima = ""
          if(maxDigitsAndDecimals(this.reply.premium) === false && this.reply.premium.toString().length > 0) {
                this.errorPrima = "Debes ingresar máximo 15 dígitos con 2 decimales."
              }else if ( maxDigitsAndDecimals(this.reply.premium) === true && this.reply.premium.toString().length > 0) {
                this.errorPrima = ""
              } else if (this.reply.premium.toString().length == 0) {
                this.errorPrima = "Debes completar este campo."
              }
        },

        clickInput() {
          let inputTasa = document.getElementById("tasa")
          inputTasa.focus()
        },

        clickPrima() {
          let inputPrima = document.getElementById("prima")
          this.isFocus = true
          inputPrima.focus()
        },

        focusPrima() {
          this.isFocus = false
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/variables.scss';
    .comment--box {
        margin-bottom: 4em;
    }

    .small {
        font-size: 12px;
        margin: 0.5em 0;
        text-align: right
    }

    .attachment {
        flex: 0;
        margin-bottom: 0;
    }
    .button {
      margin: 1em 0 0;
      transition: 0.2s ease-out;
      background-color: $ligth-grey;
      &.active {
        background-color: $primary;
      }
    }
    .strategic-wrapper {
      display: flex;
      flex-direction: column;
      margin-bottom: 10px;
    }
    .title-suscriptor {
      font-weight: bold;
      margin-bottom: 8px;
    }
    .subtitle-suscriptor {
      color: #7A7A7A;
      margin-bottom: 32px;
    }
    .tasa-wrapper {
      display: flex;
      flex-direction: column;
      width: 100%;
    }
    .tasa{
      opacity: 0;
      position: absolute;
      top: 0;
    }
    .icon-percent {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .wrapper-column  {
      display: flex;
    }
    .tasa-content {
      display: flex;
    }
    .margin {
      padding-left: 10px;
    }
    .center {
      display: flex;
      align-items: center;
      justify-content: space-between;
      &.focus {
        border: 1px solid #00cec5;
      }
    }
    .selectCurrency {
      border: 1px solid #CED4DA;
      border-radius: 4px;
      padding: 5px;
      margin-right: 8px;
    }
    .comment-area {
      margin-top: 7px;
      padding-right: 10px;
    }
    .select-technical {
      border: 1px solid #CED4DA;
      border-radius: 4px;
      height: 40px;
    }
    .money-field-wrapper {
      display: flex;
      flex-direction: column;
    }
    .input-money {
      display: flex;
    }
    .error-label {
      color: $primary;
      font-weight: 600;
    }
    .input-currency {
      width: 100%;
    }
</style>
